import { ChangeDetectionStrategy, Component, EventEmitter, Output, inject } from '@angular/core';
import { GRID_CONSTANTS } from '@go-modules/components/grid-virtual-scroll-viewport/grid.constants';
import { FolderListDataSource } from '@go-modules/services/folder-list-datasource/folder-list-datasource';
import { ResponsiveLayoutService } from '@go-modules/services/responsive-layout/responsive-layout.service';

@Component({
	selector: 'folders-grid-view',
	templateUrl: './folders-grid-view.component.html',
	styleUrls: ['./folders-grid-view.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
	host: {
		'[class]': 'responsiveLayout.cssClassString()'
	}
})
export class FoldersGridViewComponent {
	protected responsiveLayout = inject(ResponsiveLayoutService);

	@Output() public goToFolder: EventEmitter<any>  = new EventEmitter();
	public minWidth: number = GRID_CONSTANTS.minWidth;
	public maxWidth: number = GRID_CONSTANTS.maxWidth;
	public minGap: number = GRID_CONSTANTS.minGap;

	constructor (
		public folderListDataSource: FolderListDataSource
	) {}
}
